import {
  Box,
  Drawer,
  IconButton,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { MAP_ENTITY_DRAWER_WIDTH } from 'features/mapping/components/MapEntityDrawer';
import { useTranslation } from 'react-i18next';
import { BottomSheet } from 'react-spring-bottom-sheet';
import { makeStyles } from 'tss-react/mui';
import CloseIcon from '@mui/icons-material/Close';
import { useHoursDrawerState } from 'features/locations/hooks/useHoursDrawerState/useHoursDrawerState';
import {
  DOWNLOAD_APP_BANNER_OFFSET_CSS_VALUE,
  TOOLBAR_HEIGHT_DESKTOP_PX,
} from '../../../../constants';
import { HoursList } from '../HoursList';

const useStyles = makeStyles()((theme) => ({
  drawerPaper: {
    paddingTop: `calc(${TOOLBAR_HEIGHT_DESKTOP_PX}px + env(safe-area-inset-top) + ${DOWNLOAD_APP_BANNER_OFFSET_CSS_VALUE})`,
    paddingBottom: `env(safe-area-inset-bottom)`,
    width: MAP_ENTITY_DRAWER_WIDTH,
    zIndex: theme.zIndex.drawer + 2,
  },
  closeButton: {
    position: 'absolute',
    top: 6,
    right: 8,
    zIndex: 1,
    [theme.breakpoints.down('phone')]: {
      top: -8,
    },
  },
}));

export const HoursDrawer = (): JSX.Element => {
  const { classes } = useStyles();
  const theme = useTheme();
  const isPhone = useMediaQuery(theme.breakpoints.down('phone'));
  const { t } = useTranslation();
  const { open, setOpen } = useHoursDrawerState();

  const handleClose = (): void => {
    setOpen(false);
  };

  if (isPhone) {
    return (
      <BottomSheet
        id="hours-bottom-sheet"
        open={open}
        onDismiss={handleClose}
        skipInitialTransition
        snapPoints={({ maxHeight }) =>
          [0.7].map((pct) => Math.round(maxHeight * pct))
        }
        expandOnContentDrag
        blocking
        header
        scrollLocking
        aria-label={t('location.hoursDrawer')}
      >
        <Box sx={{ position: 'relative' }}>
          <HoursList />
          <IconButton
            aria-label={t('common.close')}
            className={classes.closeButton}
            onClick={handleClose}
            color="inherit"
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </BottomSheet>
    );
  }

  return (
    <Drawer
      classes={{ paper: classes.drawerPaper }}
      anchor="right"
      open={open}
      onClose={handleClose}
      variant="persistent"
      PaperProps={{ 'aria-label': t('location.hoursDrawer') }}
    >
      <Box sx={{ position: 'relative', pt: 2 }}>
        <HoursList />
        <IconButton
          aria-label={t('common.close')}
          className={classes.closeButton}
          onClick={handleClose}
          color="inherit"
        >
          <CloseIcon />
        </IconButton>
      </Box>
    </Drawer>
  );
};
